import { OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DashboardService } from '../../dashboard';
import { ErrorHandlerService } from '../../services';
var FresherJobsComponent = /** @class */ (function () {
    function FresherJobsComponent(dashboardService, errorHandlerService, router, route) {
        this.dashboardService = dashboardService;
        this.errorHandlerService = errorHandlerService;
        this.router = router;
        this.route = route;
        this.subscriptions = [];
        this.jobs = [];
        this.filter = {};
        this.msgTitle = "";
        this.msgContent = "";
        this.popUp = false;
    }
    FresherJobsComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    FresherJobsComponent.prototype.ngOnInit = function () {
        var _this = this;
        var s1 = this.dashboardService.allJobs(this.filter).subscribe(function (data) {
            console.log(data);
            _this.jobs = data;
        }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
        });
        this.subscriptions.push(s1);
    };
    FresherJobsComponent.prototype.moreJobs = function () {
        var _this = this;
        var s2 = this.dashboardService.allJobsLoad(this.filter).subscribe(function (data) {
            console.log(data);
            data.forEach(function (element) {
                _this.jobs.push(element);
            });
        }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
        });
        this.subscriptions.push(s2);
    };
    FresherJobsComponent.prototype.filterSearch = function () {
        var _this = this;
        var s3 = this.dashboardService.allJobs(this.filter).subscribe(function (data) {
            console.log(data);
            _this.jobs = data;
        }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
        });
        this.subscriptions.push(s3);
    };
    FresherJobsComponent.prototype.handleError = function (error) {
        console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.errorHandlerService.throwError(error);
    };
    FresherJobsComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (element) {
            element.unsubscribe();
        });
    };
    return FresherJobsComponent;
}());
export { FresherJobsComponent };
//# sourceMappingURL=fresherjobs.component.js.map